// src/components/filter.
import React, { useState } from "react";
import TableContainer from "../../components/Common/TableContainer";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import axios from 'axios';
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import DeleteConfirmationModal from "./DeleteConfirmationModal"

const DatatableTables = ({ itemList, loading, fetchData }) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [selectedDeleteData, setSelectedDeleteData] = useState(null)

  const openDeleteModal = rowData => {
    setSelectedDeleteData(rowData)
    setIsDeleteModalOpen(true)
  }
  const closeDeleteModal = () => {
    setSelectedDeleteData(null)
    setIsDeleteModalOpen(false)
  }
  const handleDelete = async () => {
    try {
      if (selectedDeleteData) {
        const req = await axios.delete(
          `${process.env.REACT_APP_MYAPI_URL}/deleteproduct/${selectedDeleteData}`
        )
        const res = await req.data

        if (res) {

          closeDeleteModal()
          fetchData()
        }
      }
    } catch (error) {
      console.error(error)
    }
  }
  const columns = React.useMemo(
    () => [
      {
        Header: "Product",
        accessor: "pdata.product_name",
      },
      {
        Header: "Generic Name",
        accessor: "pdata.generic_name",
      },
      {
        Header: "Pack Style",
        accessor: "pdata.packingstyle",
      },
      {
        Header: "Pack Type",
        accessor: "pdata.packingtype",
      },
      {
        Header: "Dosage Form",
        accessor: "pdata.packing",
      },
      {
        Header: "Actions",
        accessor: "_id",
        Cell: ({ value, row }) => (
          <div>
            <button className="btn btn-danger mx-2"
              onClick={() => openDeleteModal(row.original._id)}
            >Delete</button>
          </div>
        ),
      },
      // {
      //     Header: "Manufacturer",
      //     accessor: (row) => row.manufacture.map(manufacturer => manufacturer.value).join(', '),
      // },
    ],
    []
  );

  //meta title
  document.title = "Products | List";

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h1 className="page-title"></h1>
          <Link to="/Addproduct" className="btn btn-primary">ADD NEW Product</Link>
        </div>
        <Breadcrumbs title="Setting" breadcrumbItem="Products" />
        <TableContainer
          columns={columns}
          data={itemList}
          isLoading={loading}
          isGlobalFilter={true}
          isAddOptions={false}
          customPageSize={10}
          className="custom-header-css"
        />
        <DeleteConfirmationModal
          isOpen={isDeleteModalOpen}
          onClose={closeDeleteModal}
          onConfirm={handleDelete}
        />
      </div>
    </div>
  );
}
DatatableTables.propTypes = {
  preGlobalFilteredRows: PropTypes.any,

};


export default DatatableTables;